import Swiper, { Navigation } from 'swiper';
import { sendDataLayer } from './dataLayer';
import './styles.scss';

const swiperOptions = {
  direction: 'horizontal',
  slidesPerView: 'auto',
  spaceBetween: 16,
  initialSlide: 0,
  loop: false,
  modules: [Navigation],
  navigation: {
    nextEl: '.video-button-next',
    prevEl: '.video-button-prev',
  },
};

class Recommendation {
  constructor(player, data, isHero = false) {
    this.player = player;
    this.data = data;
    this.bigButton = this.player.el().querySelector('.vjs-big-play-button');
    this.player.ready(() => {
      this.createElement();
      this.recommendationContainer = this.player.el().querySelector('.video-recommendation');
      this.swiper = new Swiper(this.recommendationContainer, swiperOptions);
      this.swiper.init();
      this.swiperEvent();
      this.listenEnd(isHero);
      this.listenPlay();
    });
  }

  listenEnd(isHero) {
    this.player.on('ended', () => {
      if ((isHero && window.shouldSendRecommendationDatalayers) || !isHero) {
        this.bigButton.style.display = 'none';
        this.containerRecommendation.classList.add('active');
        sendDataLayer(this.data[0], 'content_impression', 1);
        sendDataLayer(this.data[1], 'content_impression', 2);
      }
    });
  }

  listenPlay() {
    this.player.on('play', () => {
      this.bigButton.style.display = null;
      this.containerRecommendation.classList.remove('active');
    });
  }

  swiperEvent() {
    this.swiper.on('click', () => {
      sendDataLayer(this.data[this.swiper.clickedIndex], 'content_click', this.swiper.clickedIndex + 1);
    });
    this.swiper.on('slideChange', () => {
      sendDataLayer(this.data[this.swiper.realIndex + 1], 'content_impression', this.swiper.realIndex + 1);
    });
  }

  createElement() {
    this.containerFragment = document.createDocumentFragment();
    this.containerRecommendation = document.createElement('div');
    this.containerRecommendation.classList.add('video-recommendation');

    this.prevButton = document.createElement('div');
    this.nextButton = document.createElement('div');
    this.prevButton.classList.add('video-button-prev');
    this.nextButton.classList.add('video-button-next');
    this.nextButton.innerHTML = `
    <svg width="12" height="16" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.207 11.707L7.914 5.99997L2.207 0.292969L0.792999 1.70697L5.086 5.99997L0.792999 10.293L2.207 11.707Z" fill="white"/>
    </svg>
    `;
    this.prevButton.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="white">
      <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"/>
    </svg>
    `;

    this.swiperWrapper = document.createElement('div');
    this.swiperWrapper.classList.add('swiper-wrapper');

    this.swiperSlider = document.createElement('div');
    this.swiperSlider.classList.add('swiper-slide');

    this.data.forEach((data) => {
      const _cloneNode = this.swiperSlider.cloneNode(true);
      _cloneNode.innerHTML = `
        <a href="${data.url}" class="slider-href">
          <div class="slider-image">
            <img src="${data.image.resolutions.standard?.url}" />
          </div>
          <p>${data.title}</p>
        </a>
      `;
      this.swiperWrapper.appendChild(_cloneNode);
    });
    this.containerRecommendation.insertAdjacentElement('afterbegin', this.nextButton);
    this.containerRecommendation.insertAdjacentElement('afterbegin', this.prevButton);
    this.containerRecommendation.appendChild(this.swiperWrapper);
    this.containerFragment.appendChild(this.containerRecommendation);
    this.player.el().appendChild(this.containerFragment);
  }
}

export default Recommendation;
